// Core text fields for the product draft (name, descriptions). Reads and
// writes the draft straight from the productEditor slice — no local copy.
import { useDispatch, useSelector } from 'react-redux';
import { TextField, MenuItem } from '@mui/material';
import {
  setDraftField, setDraftName, changeDraftCategory,
} from '../../../store/product-editor-slice.js';

const ProductDetailsFields = () => {
  const dispatch = useDispatch();
  const draft = useSelector((state) => state.productEditor.draft);
  const categories = useSelector((state) => state.adminCatalog.data.categories);
  const setField = (field) => (event) => dispatch(
    setDraftField({ field, value: event.target.value }),
  );

  return (
    <>
      <TextField
        label="Name"
        value={draft.name}
        onChange={(e) => dispatch(setDraftName(e.target.value))}
        required
        autoFocus
        slotProps={{ htmlInput: { maxLength: 200 } }}
      />
      <TextField
        label="Category"
        select
        value={draft.category_id}
        onChange={(e) => dispatch(changeDraftCategory(e.target.value))}
        required
        fullWidth
      >
        {categories.map((c) => (
          <MenuItem key={c.id} value={c.id}>
            {c.name}
            {!c.is_active && ' (inactive)'}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Short description"
        value={draft.short_description || ''}
        onChange={setField('short_description')}
        multiline
        minRows={2}
      />
    </>
  );
};

export default ProductDetailsFields;
